import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const PerplexityContent: SDEContent = {
  projectType: 'async_perplexity',
  projectCategory: 'perplexity',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/perplexity/search/v1`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Prompts',
      listLiteralInputPlaceholder: 'Enter one prompt per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: "Enter the prompts you want to send to Perplexity.",
    },
    projectContent: {
      title: 'Perplexity',
      description: 'Send prompts to Perplexity and receive structured answers with web search sources.',
      icon: 'perplexity',
      inputTitle: 'Prompt',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: 'Enter the prompts you want to send to Perplexity.',
    },
    projectContent: {
      title: 'Perplexity',
      description: 'Send prompts to Perplexity and receive structured answers with web search sources.',
      icon: 'perplexity',
    },
    enterInputsPlaceholder: 'Enter a prompt for Perplexity',
    enterInputsMessage: 'Enter a prompt for Perplexity',
    codeViewPlaceHolder: 'Please provide a valid prompt',
    dropdownTitle: 'Perplexity'
  }
};
